/* eslint no-undef: 0 */
export enum HintMessages {
  EditDesignButton = 'edit_design_button',
  DesignAreaSelect = 'design_area_select',
  DesignProductionMethodSelect = 'design_production_method_select',
  AddVisualElementButton = 'add_visual_element_button',
  EditVisualElement = 'edit_visual_element',
  SaveAndDownloadConfigurationButton = 'save_and_download_configuration_button',
  AddToCartButton = 'add_to_cart',
}
